<template>
  <div class="upload-container">
    <el-upload
      action="/api/1/attachments/upload"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :on-progress="uploadProgress"
    >
      <button class="global-button-style btn-style">
        {{ $t("commonMsg.upload") }}
      </button>
    </el-upload>
    <el-progress
      v-if="uploadState"
      type="line"
      :percentage="percent"
    ></el-progress>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadState: false,
      percent: 0
    };
  },
  methods: {
    uploadSuccess(data) {
      this.elMsg(this.$t("alertMsg.uploadSuccess"), "success");
      this.uploadState = false;
      this.$emit("successEvn", data);
    },

    uploadProgress(data) {
      this.uploadState = true;
      this.percent = parseInt(data.percent);
    }
  }
};
</script>

<style lang="scss">
.upload-container {
  width: 100%;
  .el-upload {
    width: 100%;
  }
}
</style>
